import type { CraftData } from "../runtime/types/core";

/**
 * Extracts the section node from a bundle and injects its child nodes
 * into the page JSON so they are available during normalization.
 */
export function unbundleSharedSection(
  sectionData: unknown,
  pageJson: CraftData,
): unknown {
  if (!sectionData || typeof sectionData !== "object") return sectionData;

  const record = sectionData as Record<string, unknown>;
  if (!("_sectionNode" in record)) return sectionData;

  if (record._childNodes && typeof record._childNodes === "object") {
    for (const [id, node] of Object.entries(
      record._childNodes as Record<string, unknown>,
    )) {
      pageJson[id] = node as CraftData[string];
    }
  }
  return record._sectionNode;
}

export function normalizeSharedSectionNodeForPage(
  sectionNode: unknown,
  pageJson: CraftData,
): unknown {
  if (!sectionNode || typeof sectionNode !== "object") return sectionNode;

  const normalized = { ...(sectionNode as Record<string, unknown>) };

  if (
    normalized.linkedNodes &&
    typeof normalized.linkedNodes === "object" &&
    !Array.isArray(normalized.linkedNodes)
  ) {
    normalized.linkedNodes = Object.fromEntries(
      Object.entries(normalized.linkedNodes as Record<string, unknown>).filter(
        ([, nodeId]) => typeof nodeId === "string" && nodeId in pageJson,
      ),
    );
  }

  if (Array.isArray(normalized.nodes)) {
    normalized.nodes = normalized.nodes.filter(
      (nodeId) => typeof nodeId === "string" && nodeId in pageJson,
    );
  }

  return normalized;
}
